import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DetailBoxContainer } from "../../../styled/scheduler";

import { IoDocumentTextOutline } from "react-icons/io5";
import { BiMap, BiUser } from "react-icons/bi";
import axios from "axios";

const DetailBox = ({ eventInfo, setActive }) => {
  const [author, setAuthor] = useState(null);
  const workers = [
    ...(eventInfo.managerNm && eventInfo.managerNo
      ? [[eventInfo.managerNo, eventInfo.managerNm]]
      : []),
    ...(eventInfo.workerList ? Object.entries(eventInfo.workerList) : []),
  ];

  const hasWorkers = workers && workers.length > 0;

  useEffect(() => {
    if (!eventInfo) return;
    getAuthor();
  }, []);

  const getAuthor = async () => {
    const url = "/api/mberList";
    const body = {
      mberNo: eventInfo.mberNo,
      offset: 0,
      pageNumber: 0,
      pageSize: 10,
      paged: false,
    };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200 && res.data.content.length > 0) {
        setAuthor(res.data.content[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const container = [
    {
      icon: BiUser,
      clickEvent: () => setActive(4),
      label: eventInfo.gbn === "C" ? "근무자" : "참여자",
      detail: hasWorkers ? (
        <div>
          {workers.slice(0, 2).map(([key, worker], i) => (
            <span key={key}>
              {worker}
              {i < 1 && workers.length > 1 && ", "}
            </span>
          ))}
          {workers.length > 2 && " ..."}
        </div>
      ) : eventInfo.gbn === "P" && author ? (
        <span>{author?.mberNm || "-"}</span>
      ) : (
        <span>-</span>
      ),
    },
    {
      icon: IoDocumentTextOutline,
      label: "공개",
      detail: <span>{eventInfo.publicYn === "Y" ? "전체공개" : "참여자공개"}</span>,
    },
    {
      icon: BiMap,
      label: "장소",
      detail: <span>{`${eventInfo.place || "-"}${eventInfo.placeDetail || ""}`}</span>,
    },
  ];

  return (
    <DetailBoxContainer>
      {container.map((box, index) => (
        <li
          key={index}
          style={{ cursor: !index ? "pointer" : "default" }}
          onClick={() => !index && box?.clickEvent && box.clickEvent()}>
          <i>
            <box.icon />
          </i>
          <strong>{box.label}</strong>
          {box.detail}
        </li>
      ))}
    </DetailBoxContainer>
  );
};

export default DetailBox;
